export default {
  QuoteRequested: "quote_requested",
  QuoteSubmitted: "quote_submitted",
  Pending: "pending",
  Processing: "processing",
  Complete: "complete",
  Draft: "draft",
};
